import * as React from 'react';
import * as Session from '../../service/Session';
import * as DTO from '../../service/DTOs';
import * as TF from '../../service/tradeflow';

import { ChatHistory } from './ChatHistory';
import { ChatInput } from './ChatInput';
import * as ChatState from './ChatState';

import { SpinnerBlock } from './../shared/effects/Spinners'
const iconSpinner = <SpinnerBlock />


type ImpactorChatProps = {
    syshdr: DTO.SystemHeader;
    user: Session.UserState,
    xsrfToken?: string,
    personalState?: Session.PersonalState,
    new_chat_messages: DTO.AgentTextMessage[],
    idchat?: number,
    lastactiv?: DTO.AgentChatActivity
};

interface ImpactorChatState {
    syshdr: DTO.SystemHeader;
    user: Session.UserState;
    messages: ChatState.ChatTextMessage[];    
    currentMessage?: string;
    allHistoryLoaded: boolean;
    isLoading: boolean;
}

export class ImpactorChat extends React.Component<ImpactorChatProps, ImpactorChatState> {

    constructor(props: ImpactorChatProps) {
        super(props);

        this.state = {
            ...{ isLoading:true,  messages: [] }, ...{ user: props.user }, ...{ syshdr: props.syshdr }, allHistoryLoaded: false
        };

        this.fetchHistory = this.fetchHistory.bind(this);
        this.readChatMessagesConfirm = this.readChatMessagesConfirm.bind(this);
    }

    componentWillReceiveProps(nextProps: ImpactorChatProps) {
        let chatChanged = nextProps.idchat !== this.props.idchat
            || (!this.props.lastactiv && nextProps.lastactiv)
            || (this.props.lastactiv && nextProps.lastactiv && this.props.lastactiv.lastmodify != nextProps.lastactiv.lastmodify);

        if (chatChanged) {
            //console.log('componentWillReceiveProps');
            //console.log(nextProps);

            this.setState({ messages: [], allHistoryLoaded: false, isLoading: true });
        }
    }

    componentDidUpdate(prevProps: ImpactorChatProps, prevState: ImpactorChatState) {
        let chatChanged = prevProps.idchat !== this.props.idchat
            || (this.props.lastactiv && !prevProps.lastactiv)
            || (this.props.lastactiv && prevProps.lastactiv && this.props.lastactiv.lastmodify != prevProps.lastactiv.lastmodify);

        if (chatChanged) {
            //console.log('componentDidUpdate');
            this.fetchHistory();
        }
    }

    fetchHistory() {
        if (this.props.idchat) {
            //console.log('fetchHistory');
            //console.log('for chat = ' + this.props.idchat);

            if (this.state.allHistoryLoaded)
                return;

            let idearliest = 0;
            if (this.state.messages.length > 0) {
                idearliest = this.state.messages[0].id;
            }

            //console.log('REQUEST. idearliest = ' + idearliest);
            TF.PublishCommandLastMessages(this.props.idchat, ChatState.batchSize - 1, idearliest);
        }
    }

    processIncomingTextMessage(that: ImpactorChat, message: DTO.AgentTextMessage) {
        if (message.idchat != this.props.idchat)
            return {};

        let messages = Object.assign([], that.state.messages);

        const chatMsg = { ...message, ...{ liElem: null } };
        messages.push(chatMsg);
        let cmsg = this.state.user.personalState ? (message.idauthor == this.state.user.personalState.idperson ? '' : that.state.currentMessage) : that.state.currentMessage;

        that.setState({
            messages: messages,
            currentMessage: cmsg
        });

        return {};
    }

    readChatMessagesConfirm(): Promise<void> {
        let _that = this;
        return new Promise(function (resolve, reject) {
            TF.ConfirmReadChat(_that.props.idchat, _that.props.syshdr.time);
            return resolve();
        });
    }

    componentDidMount() {
        TF.DataProcessBinding(this, { type: 'SYS.MSG.messages', delegate: (msgs: DTO.AgentTextMessage[]) => this.processTopMessages(msgs) });
        TF.DataProcessBinding(this, { type: 'SYS.MSG.newmessage', delegate: (msg: DTO.AgentTextMessage) => this.processIncomingTextMessage(this, msg) });
        //console.log('componentDidMount');
        this.fetchHistory();
    }

    componentWillUnmount() {
        this.leaveChat();

        TF.DataProcessUnBinding(this, { type: 'SYS.MSG.messages', delegate: (msgs: DTO.AgentTextMessage[]) => this.processTopMessages(msgs) });
        TF.DataProcessUnBinding(this, { type: 'SYS.MSG.newmessage', delegate: (msg: DTO.AgentTextMessage) => this.processIncomingTextMessage(this, msg) });
    }


    processTopMessages(messages: DTO.AgentTextMessage[]) {
        //let filtered = messages.filter((obj) => obj.idchat == this.props.idchat);

        //let keepScrollEl = undefined;
        //if (this.state.messages.length > 0) {
        //    keepScrollEl = document.getElementById("msg" + this.state.messages[0].id); 
        //}

        let filtered = Object.assign([], this.state.messages);

        const chatMsgs = messages.map((el) => { const chatMsg = { ...el, ...{ liElem: null } }; return chatMsg; });

        filtered.unshift(...chatMsgs);

        this.setState({
            messages: filtered,
            allHistoryLoaded: !(messages.length >= ChatState.batchSize),
            isLoading: false
        });

        //if (keepScrollEl && this.panelElem) {
        //    keepScrollEl.scrollIntoView();
        //}
        //else 
        //    this.scrollDown(this);

        return {};
    }

    leaveChat = () => {
        //this.PubNub.unsubscribe({ channel: 'ReactChat' });
    }

    render() {
        return (
            this.props.idchat ? 
                (
                    this.state.isLoading ?
                        <div>{iconSpinner}</div>
                        :
                        <div>
                            <ChatHistory {...this.props} readChatMessagesConfirm={this.readChatMessagesConfirm} fetchHistory={this.fetchHistory.bind(this)} messages={this.state.messages} allHistoryLoaded={this.state.allHistoryLoaded} />
                            <ChatInput {...this.props} />
                        </div>
                )
                :
                <div>Чат не найден или более не доступен</div>
        );
    }
}